import React from 'react';
import { Divider } from '@jjj/components';
import { SelectAllTooltip } from './selectionTooltip.style';
import SelectByStatusList from './selectByStatusList';
import BulkActionsList from './bulkActionsList';

const SelectionTooltip = ({
  loading,
  actions,
  onActionClick,
  onSelectBulkByField,
  statuses = [],
  selectByStatusEnabled,
}) => (
  <SelectAllTooltip>
    {selectByStatusEnabled && statuses.length > 0 && (
      <SelectByStatusList statuses={statuses} onStatusSelect={onSelectBulkByField} />
    )}

    <Divider />

    <BulkActionsList loading={loading} actions={actions} onActionClick={onActionClick} />
  </SelectAllTooltip>
);

export default SelectionTooltip;
